import React from 'react';
import styled from 'styled-components';
import { InputChange } from '../types';
import { RFC } from 'state/StateTypes';

interface Props {
   checked: boolean;
   onChange: (e: InputChange) => void;
   label: string;
}

const Checkbox: RFC<Props> = ({ checked, label, onChange }) => (
   <CheckBoxLabel>
      {/* 
  // @ts-ignore */}
      <CheckboxSpanActingAsLabel checked={checked}>{label}</CheckboxSpanActingAsLabel>
      <CheckboxContainer>
         <HiddenCheckbox checked={checked} onChange={onChange} />
         <StyledCheckbox checked={checked}>
            <Icon viewBox="0 0 24 24">
               <polyline points="20 6 9 17 4 12" />
            </Icon>
         </StyledCheckbox>
      </CheckboxContainer>
   </CheckBoxLabel>
);

const CheckBoxLabel = styled.label`
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-content: center;
   align-items: center;
`;
const CheckboxSpanActingAsLabel = styled.span`
   color: ${({ theme }) => theme.almostBlack};
   margin: 0 0 10px 10px;
   transition-duration: 250ms;
`;

const CheckboxContainer = styled.div`
   display: inline-block;
   vertical-align: middle;
   margin: 7px 12px 0 0;
`;

const Icon = styled.svg`
   fill: none;
   stroke: white;
   stroke-width: 2px;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
   border: 0;
   clip: rect(0 0 0 0);
   clip-path: inset(50%);
   height: 1px;
   margin: -1px;
   overflow: hidden;
   padding: 0;
   position: absolute;
   white-space: nowrap;
   width: 1px;
   transition-duration: 200ms;
`;

const StyledCheckbox = styled.div`
   display: inline-block;
   width: 24px;
   height: 24px;
   background: ${({ checked, theme }: { checked: boolean; theme: any }) => (checked ? theme.secondaryBlueDark : theme.primaryWhite)};
   border-radius: 3px;
   transition: all 150ms;

   ${HiddenCheckbox}:focus + & {
      box-shadow: 0 0 0 3px pink;
   }

   ${Icon} {
      visibility: ${({ checked }: { checked: boolean }) => (checked ? 'visible' : 'hidden')};
   }
   &:hover {
      cursor: pointer;
      background-color: ${({ theme, checked }: { checked: boolean; theme: any }) => (checked ? theme.secondaryGreen : theme.primaryGrey)};
   }
`;

export default Checkbox;
